import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
// ngrx store
import { Store } from '@ngrx/store';
// services
import { DataStorageService } from '../../../shared/services/data-storage.service';
import { ErrorHandler } from '../../../shared/services/error-handler.service';
// models
import { AppState } from '../../../booking/models/app-state.interface';

declare var ga: any;

@Component({
  selector: 'app-register-section',
  templateUrl: './register-section.component.html',
  styleUrls: ['./register-section.component.scss'],
  providers: [ErrorHandler, DataStorageService]
})
export class RegisterSectionComponent implements OnInit {

  constructor(
    private _dataStorageService: DataStorageService,
    private _appStore: Store<AppState>,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      ga('set', 'page', '/register');
      ga('send', 'pageview');
    }

    this._dataStorageService.removeCookie('DataID');
    this._appStore.dispatch({ type: 'RESET_USER_STATE' });
  }

}
